import { pathOr } from 'ramda';
import { useSessionHook } from 'src/hooks/useSessionHook';
import { returnIsNotEmptyOrTrue, isNotEmpty } from 'src/utilities/hasValue';


interface IAutoMatch {
  advisorUsername: any;
  generateCustomData: any;
}

export class AutoMatchCreate implements IAutoMatch {
  advisorUsername: any;
  constructor() {
    const { advisorUsername } = useSessionHook();
    this.advisorUsername = advisorUsername;
  }
  private getAutoMatchConfigName(eventContext: any) {
    return pathOr('', ['automatch_config_name'], eventContext);
  }

  private getOnBoardCustomData(eventContext: any) {
    return pathOr({}, ['custom_data'], eventContext);
  }


  private getAdvisorUserName(eventContext: any) {
    return returnIsNotEmptyOrTrue(
      this.advisorUsername,
      this.advisorUsername,
      pathOr('', ['automatch_user_name'], eventContext)
    );
  }

  generateCustomData(eventContext: any) {
    const configName = this.getAutoMatchConfigName(eventContext);
    const advisorName = this.getAdvisorUserName(eventContext);
    const customData = this.getOnBoardCustomData(eventContext)
    if (isNotEmpty(advisorName)) {
      return {
        pod_config_name: 'user_name_auto_match',
        advisor_user_name: advisorName,

      };
    }
    if (isNotEmpty(configName)) {
      return {
        pod_config_name: configName,

      };
    }
    if (isNotEmpty(customData)) {
      return customData;
    }
    return {}
  }
}
